/**
 * @author mll
 * @description 打包下载
 * @Date 2021/04/23
 */

import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils'
import saveAs from 'file-saver';
import { component_tool } from '@/tool';
let { Wizmessage } = component_tool;

const downLoadBiz = (title, pageData) => {
    let fileList = [{ title, arr: pageData }];
    let laseTime = null;
    let downloadMessage = (msg, type = 'loading', duration = 8) => {
        Wizmessage[type]({
            content: msg || '批量下载准备中...',
            key: 'download',
            duration
        });
    }
    downloadMessage()
    fileList.forEach((arrItem, i) => {
        if (arrItem.arr.length > 0) {
            arrItem.arr.forEach((item) => {
                if (laseTime) {
                    clearTimeout(laseTime);
                }
                clearInterval(this.djs)
                laseTime = setTimeout(() => {
                    const ZIP = new JSZip();
                    const file = ZIP.folder(arrItem.title);
                    let count = 0;
                    let errorCount = 0;
                    arrItem.arr.forEach(item => {
                        if (item.url) {
                            JSZipUtils.getBinaryContent(item.url, function (err, data) {
                                if (err) {
                                    console.log(err); // or handle the error
                                    Wizmessage.error(`批量下载:文件 ${item.kname} 批量处理出错`);
                                    errorCount++
                                }
                                file.file(item.kname, data, { binary: true });
                                count++
                            });
                        }
                    });
                    this.djs = setInterval(() => {
                        if (count && count === (arrItem.arr.length - errorCount)) {
                            downloadMessage('批量下载:文件处理完毕', 'success', 3)
                            ZIP.generateAsync({ type: 'blob' }).then(
                                function (content) {
                                    saveAs(content, title + '.zip');
                                });
                            clearInterval(this.djs)
                        } else {
                            downloadMessage(`批量下载:文件处理中(${count}/${arrItem.arr.length}),请稍后...`)
                        }
                    }, 500);
                }, 1500);
            });
        }
    });
}

export { downLoadBiz }